<template>
  <div class="uploader-widget-container">
     <div class="trigger-btn" @click="isCollapsed = !isCollapsed" :class="{isActive: !isCollapsed}">
       <span class="material-icons">
        style
        </span>
     </div>
     <section class="uploader-widget card-1" :class="{collapsed: isCollapsed}">
        <attachable-files heading="Upload Files"/>
     </section>
  </div>
</template>

<script>
  import AttachableFiles from './attachable-files';
  export default {
    data(){
      return {
        isCollapsed: true
      }
    },
    components: {AttachableFiles}
  }
</script>

<style lang="scss" scoped>
  .uploader-widget-container{
     position: fixed;
     left: 20px;
     bottom:20px;
     z-index: 1000;
  }
  .uploader-widget{
    background-color: #fff;
    border-radius:5px;
    width: 500px;
    padding: 20px;
    position: absolute;
    left: 60px;
    bottom: 40px;
    z-index: 99;
    transition-timing-function: cubic-bezier(0.64, 0.57, 0.67, 1.53);
    transition: all 600ms cubic-bezier(0.68, -0.55, 0.265, 1.55); 
    transform-origin: bottom left;
    &.collapsed{
      transform: scale(0);
      opacity: 0;
    }
  }
  .trigger-btn{
     color: #fff;
     background-color: rgb(67, 74, 83);
     width: 50px;
     height: 50px;
     left: 20px;
     bottom: 20px;
     text-align: center;
     line-height: 65px;
     border-radius: 50%;
     cursor: pointer;
     transition: all 200ms ease;
     &.isActive{
       background-color: rgb(90, 223, 38);
     }
  }
</style>